import { useEffect, useState } from "react";
import axios from "axios";

export default function useAuth(code) {
  const [accessToken, setAccessToken] = useState();
  const [refreshToken, setRefreshToken] = useState();
  const [expiresIn, setExpiresIn] = useState();

  useEffect(() => {
    axios
      .post(
        "https://spotify-karaoke-serverapi-production.up.railway.app/login",
        { code, mode: "cors", credentials: "include" }
      )
      .then((res) => {
        setAccessToken(res.data.accessToken);
        setRefreshToken(res.data.refreshToken);
        setExpiresIn(res.data.expiresIn);
        window.history.pushState({}, null, "/");
      })
      .catch((err) => {
        console.log(err);
        // window.location = "/";
      });
  }, [code]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!refreshToken || !expiresIn) return;
      axios
        .post(
          "https://spotify-karaoke-serverapi-production.up.railway.app/refresh",
          {
            refreshToken,
            mode: "cors",
            credentials: "include",
          }
        )
        .then((res) => {
          setAccessToken(res.data.accessToken);
          setExpiresIn(res.data.expiresIn);
          window.history.pushState({}, null, "/");
        })
        .catch((err) => {
          console.log(err);
          // window.location = "/";
        });
    }, (expiresIn - 60) * 1000);

    return () => clearInterval(interval);
  }, [refreshToken, expiresIn]);

  return accessToken;
}
